import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormStore } from 'core/forms/FormStore';

import RegisterForm from './RegisterForm';
import './register.scss';
import registerFormValues from './registerFormValues';

const formStore = new FormStore(registerFormValues);

@observer
class Register extends Component {
  render() {
    return (
      <div className="register-page">
        <div className="page-body">
          <RegisterForm formStore={formStore} />
        </div>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/containers/Register/Register.jsx